export default {
  labels: {
    reply: 'Risposta del titolare',
  },
  form: {
    reply_text: {
      placeholder: 'Scrivi la tua risposta...',
    },
  },
  buttons: {
    generate_reply: 'Genera risposta',
    submit_reply: 'Invia risposta',
  },
  toasts: {
    failed_to_create_reply: 'Impossibile creare la risposta',
    failed_to_generate_ai_reply: 'Impossibile generare la risposta AI',
  },
};
